import { cloneElement, forwardRef, isValidElement } from "react"
import { usePopover } from "./usePopover"
import { mergeRefs } from "../utils/mergeRefs"
import type { PopoverTriggerProps } from "./types"

export const PopoverTrigger = forwardRef<HTMLDivElement, PopoverTriggerProps>(
  ({ children, className, ...rest }, ref) => {
    const { floating, interactions } = usePopover()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childrenRef = mergeRefs(floating?.refs.setReference ?? null, (children as any).ref)

    return (
      <div ref={ref} className={className} {...rest}>
        {isValidElement(children) &&
          cloneElement(children, {
            ref: childrenRef,
            ...children?.props,
            ...interactions?.getReferenceProps(),
          })}
      </div>
    )
  },
)

PopoverTrigger.displayName = "PopoverTrigger"
